/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ApiRootLinkRel, ApiRootResource, ApiRootService } from '@common/api-root-shared';
import { ApiBasedService, ListResourceServiceConfig, ResourceServiceConfig, StateResource } from '@common/tech-shared';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HintListLinkRel } from './hint.linkrel';
import { HintMessageCode } from './hint.message';
import { Hint, HintListResource, HintResource } from './hint.model';
import { hasHintCode } from './hint.util';

@Injectable()
export class HintService extends ApiBasedService<
  HintResource,
  HintResource,
  ApiRootResource,
  HintListResource,
  HintResource,
  Hint
> {
  getListResourceConfig(): ListResourceServiceConfig<ApiRootResource> {
    const apiRootService = inject(ApiRootService);
    return {
      baseResource: apiRootService.getApiRoot(),
      getLinkRel: ApiRootLinkRel.HINTS,
      listResourceListLinkRel: HintListLinkRel.HINT_LIST,
    };
  }

  getResourceConfig(): ResourceServiceConfig<HintResource> {
    return undefined;
  }

  getFeatureName(): string {
    return 'Hint';
  }

  public refresh(): void {
    this.markListAsReload();
  }

  public hasUserNoOrganisationsEinheitIdHint(): Observable<boolean> {
    return this.getList().pipe(
      map((stateResource: StateResource<HintListResource>) =>
        hasHintCode(stateResource.resource, HintMessageCode.USER_NO_ORGANISATIONS_EINHEIT_ID),
      ),
    );
  }

  public hasNewRequestedDatenfreigabe(): Observable<boolean> {
    return this.getList().pipe(
      map((stateResource: StateResource<HintListResource>) => stateResource.resource?.hasNewRequestedDatenfreigabe),
    );
  }
}
